import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";
import axiosInstance from "src/store/features/auth/axiosCSRF";
export interface iDeleteLibraryState{
    group_name : string;
    library_name : string;
    isLoading : boolean;
    message : string | null;
    response : any[];
}


const initialState: iDeleteLibraryState = {
    group_name: "",
    library_name: "",
    isLoading: false,
    message: "",
    response: [],
};


// Delete Library API 호출
export const deleteLibraryAPI = createAsyncThunk(
    "DELETE_LIBRARY",
    async (params: {group_name : string, library_name : string}, { rejectWithValue }) => {
        try {
            
            const pathParam = '/library/delete/';
            const djangoEndpoint = getDjangoEndpoint();
            const response = await axiosInstance.post(`${djangoEndpoint}${pathParam}`, {
                group_name: params.group_name,
                library_name: params.library_name,
            }, {
                withCredentials: true,
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// Delete Library Slice
export const deleteLibrarySlice = createSlice({
    name: "deleteLibrary",
    initialState,
    reducers: {},
    extraReducers: (builder) => {  
        builder
            .addCase(deleteLibraryAPI.pending, (state) => {
                state.isLoading = true;
                state.message = "";
            })
            .addCase(deleteLibraryAPI.fulfilled, (state, action) => {
                state.isLoading = false;
                state.response = action.payload;
            })
            .addCase(deleteLibraryAPI.rejected, (state, action) => {
                state.isLoading = false;
                state.message = action.payload as string;
            });
    }
});


export default deleteLibrarySlice.reducer;